import {useQuery} from '@tanstack/react-query'
import {api} from '@/lib/api'
import {base} from '@/hooks/bateria/use-bateria'

type PaginaImagen = {url: string}

/** Aparte de la tarjeta para no engordar los tramos de la cola; la clave es (paquete, número) para que los
 * campos que comparten hoja hagan una sola consulta. */
export function usePaginaImagen(
  businessId: string,
  evaluacionId: string,
  paqueteId: string | null,
  numero: number | null
) {
  return useQuery({
    queryKey: ['bateria-pagina-imagen', businessId, evaluacionId, paqueteId, numero],
    queryFn: async () =>
      (
        await api.get<PaginaImagen>(
          `${base(businessId)}/evaluaciones/${evaluacionId}/paquetes/${paqueteId}/paginas/${numero}/imagen`
        )
      ).data,
    enabled: businessId !== '' && evaluacionId !== '' && paqueteId !== null && numero !== null,
    // La hoja no cambia durante la revisión y su URL firmada vive 8 horas.
    staleTime: Infinity,
    retry: false,
  })
}
